<template>
  <b-navbar toggleable="lg" type="light" variant="warning">
    <b-navbar-brand href="https://codingbee.my">CodingBee.my</b-navbar-brand>
    <b-navbar-nav class="ml-auto">
      <b-nav-item v-if="user.uid == ''" class="mr-2" href="/login">
        Login
      </b-nav-item>
      <b-nav-item v-if="user.uid != ''" class="mr-2" to="/">
        Home
      </b-nav-item>
      <b-nav-item v-if="user.uid != ''" class="mr-2" to="/dashboard">
        Dashboard
      </b-nav-item>
      <b-nav-item-dropdown class="mr-2" v-if="user.uid != ''" right>
        <!-- Using 'button-content' slot -->
        <template v-slot:button-content>
          <em>{{ user.email }}</em>
        </template>
        <b-dropdown-item href="/profile">Profile</b-dropdown-item>
        <b-dropdown-item @click="onSignOut">Sign Out</b-dropdown-item>
      </b-nav-item-dropdown>
      <b-button
        href="https://codingbee.my/contact"
        class="my-2 my-sm-0"
        variant="light"
        pill
      >
        Contact Us
      </b-button>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import authServices from "@/services/auth-services";

export default {
  name: "navbar",

  computed: {
    ...mapState(["user"])
  },

  methods: {
    ...mapMutations("user", ["resetUser"]),

    onSignOut() {
      if (confirm("Confirm sign out?")) {
        authServices.signoutUser().then(() => {
          this.resetUser();
          this.$router.push("/");
        });
      }
    }
  }
};
</script>

<style></style>
